/*
  this module wraps each function declared in `rawStateInterface` with `react#setState`
  - SUPPLIED FUNCTIONS (`rawStateInterface`)
    - an object of functions
    - each function must return an object that describes how `state` should change
  - RETURNED FUNCTIONS (`stateInterface`)
    - each function will update `state` when called, as described in `rawStateInterface`
*/

import { useState } from 'react'

export default (initialState, rawStateInterface) => {
  const [state, setState] = useState(initialState)

  const stateInterface = {}
  for (const [stateChangeName, getStateChanges] of Object.entries(rawStateInterface)) {
    stateInterface[stateChangeName] = (...arguments_) => {
      const stateChanges = getStateChanges(...arguments_)
      const upcomingState = { ...state, ...stateChanges }
      return setState(upcomingState)
    }
  }

  return {
    setState: stateInterface,
    state,
  }
}
